module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "contents-jion"
  }, [_c('h3', {
    staticClass: "title-text"
  }, [_vm._v("招聘精英")]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s(_vm.$t("contact.tab2_address_label_1")))]), _vm._v(" "), _c('p', [_vm._v("18601311912")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s(_vm.$t("contact.tab2_address_label_2")))]), _vm._v(" "), _c('p', [_vm._v("hr@tintinhealth.com")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s(_vm.$t("contact.tab2_address_label_3")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("contact.tab2_address_3")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43ce1ba1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact/recruitment.vue
// module id = 267
// module chunks = 1